export default __webpack_public_path__ + "static/media/rankSymGolden.d660b539.svg";